import * as React from 'react';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';

import { TextView } from 'src/core/ui/text.view';
import { CurrencyEditorView } from 'src/app/general/currencies/parts/currency-editor.view';
import { UserEditorController } from 'src/app/general/users/parts/user-editor.controller';
import { LanguageEditorController } from 'src/app/general/language/parts/language-editor.controller';

interface SupplierGeneralPartViewProps extends ComponentViewProps<SupplierItem> {
	mode: ControlMode;
	onModeChanged: (mode: ControlMode) => void;
	currencies: DropdownRequest<CurrencySummary>;
	onLogoChange: (ev: React.ChangeEvent<HTMLInputElement>) => void;

}

@observer
export class SupplierGeneralPartView extends React.Component<SupplierGeneralPartViewProps, any> {
	public constructor(props) {
		super(props);
	}

	public render() {
		const model = this.props.model;
		const mode = this.props.mode;
		let logo;
		if (model.logo != null && model.logo.length > 0) {
			let str = "";
			for (let i = 0; i < model.logo.length; i++) {
				str += String.fromCharCode(model.logo[i]);
			}
			logo = btoa(str);
		}
		return (
			<React.Fragment>
				<Row gutter={16}>
					<Col span={24}>
						<TextView
							onGetErrorMessage={() => this.props.model.validate(false, 'title')}
							required
							mode={mode} label='Title' value={model.title} onChanged={newVal => model.title = newVal} />
					</Col>
					<Col span={24}>
						<label>
							Logo
						</label>
						<label htmlFor='logo' className="label-image text-center">
							<img src={'data:image/png;base64,' + logo} style={{ width: "100%" }} alt="Select an image" />
							<input id="logo" type="file" style={{ display: 'none' }} disabled={this.props.mode=="display"} accept="image/*" onChange={this.props.onLogoChange} />
						</label>
					</Col>
					<Col xs={24}>
						<CurrencyEditorView
							label='Default currency'
							required mode={mode}
							onChange={(item) => model.defaultCurrencyId = item.id}
							value={model.defaultCurrencyId}
							currencies={this.props.currencies}
							currencyArrayObjectType={false}
							onGetErrorMessage={() => this.props.model.validate(false, 'defaultCurrencyId')}
						/>
					</Col>
					<Col xs={24}>
						<LanguageEditorController
							setBusy={this.props.setBusy}
							mode={this.props.mode}
							value={model.dynamicProperties["language"]}
							onGetErrorMessage={() => this.props.model.validate(false, 'dynamicProperties')}
							onChanged={newVal => model.dynamicProperties["language"] = newVal}
							required
						/>
					</Col>
					<Col xs={24}>
						<UserEditorController
							isRole={false}
							onGetErrorMessage={() => this.props.model.validate(false, 'managedById')}
							setBusy={this.props.setBusy}
							mode={this.props.mode}
							value={model.managedById}
							onChanged={newVal => model.managedById = newVal ? newVal.id : undefined}
							required
							label='Managed by'
						/>
					</Col>
					<Col xs={24}>
						<TextView
							onGetErrorMessage={() => this.props.model.validate(false, 'defaultMargin')}
							required
							mode={mode}
							label='Default Margin'
							format='percent'
							value={model.defaultMargin}
							suffix='%'
							onChanged={newVal => {
								newVal = newVal != null ? parseFloat(newVal) : null;
								model.defaultMargin = newVal;
							}}
						/>
					</Col>
				</Row>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/suppliers/form/parts/suppliergeneral-part.view.tsx